import { useRef } from "react";

import config from "@/config";
import FormError from "@/shared-components/error/components/FormError";
import ImageUpdateLoader from '@/shared-components/loader/special-loaders/ImageUpdateLoader';

import UploadCover from "./components/UploadCover";

import "./index.css";

export default function Cover({ formState, setFormState, element, formError, setFormError, previewMode, onCropPopupToggle }) {
  const onImageUploadRef = useRef(null); // Ref to store onImageUpload

  const handleCoverClick = () => {
    if (onImageUploadRef.current) {
      onImageUploadRef.current(); // Call the file upload dialog
    } else {
      console.error("onImageUpload function is not available!");
    }
  }; 
  
  return (
    <>
      <div
        className={`post-cover__container ${formState.post_cover?.image_id ? "has-cover" : ""}`}
        onClick={previewMode ? undefined : handleCoverClick} // Disable click in preview mode
        style={{
          ...(formState.post_cover?.image_id
            ? { backgroundImage: `url(${config.app.imageServiceDomain}/${formState.post_cover?.image_id}/w=600)` }
            : null),
          ...(previewMode ? { pointerEvents: "none" } : {})  // Prevent pointer events if previewMode is true
        }}
      >
        {/* Show "Add a cover" text only when no cover is uploaded and not in preview mode */}
        {!formState.post_cover?.loading && !formState.post_cover?.image_id && !previewMode && (
          <p className="post-cover__add-cover-text">Add a cover</p>
        )}
        {
          formState.post_cover?.loading && (
            <div className="post-cover__loading-overlay">
              <ImageUpdateLoader className="post-cover__loading-spinner" />
            </div>
          )
        }
      </div>

      {/* Error handling */}
      <div id={`${element}_error`} className="hidden-error-placeholder"></div>
      <FormError
        error={formError}
        alternativeElement={`${element}_error`}
        errorClassName="post-cover__error-classname"
        element={element}
      />
      {/* Render UploadCover only if not in preview mode */}
      {!previewMode && (
        <UploadCover 
          formState={formState}
          setFormState={setFormState}
          element={element}
          setFormError={setFormError}
          onImageUploadRef={onImageUploadRef} // Pass the ref
          onCropPopupToggle={onCropPopupToggle}
          croppedContainerClass="hide-cover-container" // we pass this class otherwise it is repeated
        />
      )}
    </>
  );
}
